import { useParams, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import PageContainer from '../Components/PageContainer';
import useGetProcessedTimesheetDetails from '../hooks/useGetProcessedTimesheetDetails';
import ProcessedTimesheetDetailsTable from '../Components/ProcessedTimesheets/ProcessedTimesheetDetailsTable';
import { isPtsReadOnly } from '../Configurations/processedTimesheetsConfig';

const useInitialSortQueryParams = () => {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const field = params.get('sortField') || 'date';
    const sort = params.get('sortDirection') || 'asc';
    return [{ field, sort }];
};

const ProcessedTimesheetDetailsTablePage = () => {
    const { id: processedTimesheetId } = useParams();
    const { data: timesheetDetailsData, isLoading } = useGetProcessedTimesheetDetails({
        processedTimesheetId,
    });
    const initialSortModel = useInitialSortQueryParams();
    const readOnly = isPtsReadOnly(timesheetDetailsData?.status);

    return (
        <PageContainer>
            <Box sx={{ paddingRight: '30px' }}>
                <ProcessedTimesheetDetailsTable
                    initialSortModel={initialSortModel}
                    data={timesheetDetailsData?.processedTimesheetEntries || []}
                    isLoading={isLoading}
                    availableRates={timesheetDetailsData?.availableRates || []}
                    hideOpenButton
                    readOnly={readOnly}
                />
            </Box>
        </PageContainer>
    );
};

export default ProcessedTimesheetDetailsTablePage;
